<template>
    <o-form-group
        :id="this_id"
        :form-state="formState"
        :label="label"
        :message="errorMessages"
        :nolabel="nolabel"
        :type="{ 'is-danger': hasError }"
    >
        <BFormTags
            :id="this_id"
            :class="input_class"
            :disabled="_is_readonly"
            :value="value"
            remove-on-delete
            separator=",;"
            @input="on_input"
        ></BFormTags>
    </o-form-group>
</template>

<script>
import { BFormTags } from "bootstrap-vue";
import FormComponentMixin from "../../../mixins/form_component_mixin.js";
import OFormGroup from "../OFormGroup.vue";

export default {
    name: "OTagInput",
    components: {
        BFormTags,
        OFormGroup,
    },
    mixins: [FormComponentMixin],
    props: {},
    data() {
        return {};
    },
    computed: {},
    methods: {},
};
</script>

<style scoped></style>
